module.exports = __webpack_public_path__ + "img/little-symmetry-good.b3b83767.svg";